import { useEffect } from 'react';

const GoogleAnalytics = ({ measurementId = 'G-S0SB6TYEB9' }) => {
  useEffect(() => {
    // Enhanced GA4 configuration
    if (window.gtag) {
      window.gtag('config', measurementId, {
        page_title: document.title,
        page_location: window.location.href,
        send_page_view: true,
        // Enhanced ecommerce tracking
        allow_enhanced_conversions: true,
        // Core Web Vitals tracking
        custom_map: {
          'custom_parameter_1': 'page_load_time',
          'custom_parameter_2': 'user_engagement'
        }
      });

      // Track Core Web Vitals
      const trackWebVitals = () => {
        if ('PerformanceObserver' in window) {
          // Largest Contentful Paint
          new PerformanceObserver((list) => {
            const entries = list.getEntries();
            const lastEntry = entries[entries.length - 1];
            window.gtag('event', 'web_vitals', {
              event_category: 'Web Vitals',
              event_label: 'LCP',
              value: Math.round(lastEntry.startTime),
              non_interaction: true
            });
          }).observe({ entryTypes: ['largest-contentful-paint'] });

          // First Input Delay
          new PerformanceObserver((list) => {
            list.getEntries().forEach(entry => {
              window.gtag('event', 'web_vitals', {
                event_category: 'Web Vitals',
                event_label: 'FID',
                value: Math.round(entry.processingStart - entry.startTime),
                non_interaction: true
              });
            });
          }).observe({ entryTypes: ['first-input'] });

          // Cumulative Layout Shift
          let clsValue = 0;
          new PerformanceObserver((list) => {
            list.getEntries().forEach(entry => {
              if (!entry.hadRecentInput) {
                clsValue += entry.value;
              }
            });
            window.gtag('event', 'web_vitals', {
              event_category: 'Web Vitals',
              event_label: 'CLS',
              value: Math.round(clsValue * 1000),
              non_interaction: true
            });
          }).observe({ entryTypes: ['layout-shift'] });
        }
      };

      // Track scroll depth
      const trackScrollDepth = () => {
        let maxScroll = 0;
        const trackScroll = () => {
          const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
          if (scrollPercent > maxScroll && scrollPercent % 25 === 0) {
            maxScroll = scrollPercent;
            window.gtag('event', 'scroll', {
              event_category: 'User Engagement',
              event_label: `${scrollPercent}%`,
              value: scrollPercent
            });
          }
        };
        window.addEventListener('scroll', trackScroll, { passive: true });
      };

      trackWebVitals();
      trackScrollDepth();
    }
  }, [measurementId]);

  return null;
};

// Conversion tracking functions
export const trackConversion = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'Conversions',
      ...parameters
    });
  }
};

export const trackFormSubmission = (formName) => {
  trackConversion('form_submit', {
    event_label: formName,
    value: 1
  });
};

export const trackButtonClick = (buttonName, location) => {
  if (window.gtag) {
    window.gtag('event', 'click', {
      event_category: 'User Interaction',
      event_label: buttonName,
      custom_parameter_1: location
    });
  }
};

export default GoogleAnalytics;